/**
 * Utilitaires pour la détection de langue du navigateur
 */
import logger from './utils/logger';

/**
 * Détecte la langue préférée du navigateur
 * @returns {string} 'fr' ou 'nl' selon la langue détectée
 */
export const detectBrowserLanguage = () => {
  // Récupère la langue du navigateur
  const browserLang = navigator.language || navigator.languages?.[0] || 'fr-FR';

  // Normalise la langue (prend les 2 premiers caractères)
  const langCode = browserLang.substring(0, 2).toLowerCase();

  // Si c'est du français, retourne 'fr'
  if (langCode === 'fr') {
    return 'fr';
  }

  // Toutes les autres langues redirigent vers néerlandais
  return 'nl';
};

/**
 * Détermine la langue à utiliser : cookie mazout en priorité, sinon browser
 * @returns {string} 'fr' ou 'nl'
 */
export const getFuelMatchLanguage = () => {
  try {
    if (typeof window !== 'undefined') {
      const userLang = localStorage.getItem('USERLANG');
      if (userLang) {
        return userLang.startsWith('fr') ? 'fr' : 'nl';
      }
    }

    const detectedLang = detectBrowserLanguage();
    return ['fr', 'nl'].includes(detectedLang) ? detectedLang : 'nl';
  } catch (error) {
    logger.warn('Language detection error:', error);
    return 'nl';
  }
};

export default { detectBrowserLanguage, getFuelMatchLanguage };
